import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Star, Eye, EyeOff, Mail } from "lucide-react";
import api from "@/lib/api";

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }); }
  catch { return ""; }
};

export default function TestimonialsTab() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/testimonials").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggleHide = async (t) => {
    const hidden = !t.hidden;
    await api.put(`/admin/testimonials/${t.id}/hide`, { hidden });
    toast.success(hidden ? "Hidden from public page" : "Now visible publicly");
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Permanently delete this review? This cannot be undone. Use 'Hide' instead to keep the data.")) return;
    await api.delete(`/admin/testimonials/${id}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-reviews">
      <h1 className="font-display font-bold text-3xl mb-1">Reviews</h1>
      <p className="text-ink/60 mb-6">All reviews are public by default. Hide any you don't want shown — the data is kept.</p>

      {items.length === 0 ? (
        <div className="brut-card p-6 text-ink/60">No reviews yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((t) => (
            <div key={t.id} className={`brut-card p-5 ${t.hidden ? "bg-ink/5 opacity-80" : ""}`} data-testid={`review-${t.id.slice(0, 8)}`}>
              <div className="flex justify-between items-start">
                <div className="flex gap-0.5">
                  {[...Array(t.rating || 0)].map((_, i) => <Star key={i} className="w-4 h-4 fill-ink text-ink" />)}
                </div>
                <span className={`tag-pill ${t.hidden ? "bg-ink/15" : "bg-green-200"}`}>{t.hidden ? "Hidden" : "Live"}</span>
              </div>

              {(t.text || t.message) && <p className="text-ink/90 mt-3">“{t.text || t.message}”</p>}

              <p className="text-ink/50 text-xs font-bold mt-3">{fmt(t.created_at)}</p>
              {t.email && (
                <p className="text-ink/70 text-sm mt-1 flex items-center gap-1.5" data-testid={`review-email-${t.id.slice(0, 8)}`}>
                  <Mail className="w-4 h-4" /> {t.email}
                </p>
              )}

              <div className="flex gap-2 mt-4">
                <button onClick={() => toggleHide(t)} className="brut-btn !py-2 !px-4 bg-sky text-sm" data-testid={`hide-toggle-${t.id.slice(0, 8)}`}>
                  {t.hidden ? <><Eye className="w-4 h-4" /> Show</> : <><EyeOff className="w-4 h-4" /> Hide from public page</>}
                </button>
                <button onClick={() => del(t.id)} className="brut-btn !py-2 !px-4 bg-white text-sm" data-testid={`delete-review-${t.id.slice(0, 8)}`}>
                  <Trash2 className="w-4 h-4" /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
